import DatePicker from "react-datepicker";
import React from "react";
import { useTranslation } from "react-i18next";
import selectStyle from "../../design/selectStyle";
import Select from "react-select";
import func from "../../services/functions";
import InternalPoCombo from "./columns/internalPOCombo";
import InternalAgreementCombo from "./columns/internalAgreementCombo";
import { useAppContext } from "../../AppContext";


const InternalInfo = ({ invoice, handleChange }) => {
  const {
    user: [user],
    selectedCompany: [selectedCompany],
  } = useAppContext();

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );


  const { t } = useTranslation("translations");

  const priorityOptions = [
    {label : t("invoice.selectOptions"),value:""},
    { label: t("invoice.low"), value: "Low" },
    { label: t("invoice.medium"), value: "Medium" },
    { label: t("invoice.high"), value: "High" },
  ];

  const tcrList = React.useMemo(() =>
  {

    let tcrList=[]
    company.branches
    .reduce((acc,branch)=> branch?.tcrTypes?.length>0?acc.concat(branch.tcrTypes):acc,[])
    .forEach(tcr=>{
      if(tcr?.allowPurchase){
      let sellerName=company?.branches?.find((branch)=>branch?.businUnitCode==tcr?.businUnitCode)?.sellerName ?? ""
        tcrList.push({label:tcr.tcrCode +" - "+ sellerName,value:tcr.tcrCode})
      }
    })
    return tcrList.length>0 ?[{label:"Select",value:null}].concat(tcrList):tcrList
  },[selectedCompany])


  return (
    <div className="card border-0 shadow-sm mb-3">
      <div className="d-flex justify-content-between header border-bottom py-2 px-3">
        <label className="fw-bold mb-0" style={{fontSize:"16px", fontWeight:600}}>
          {t("invoice.internalInfo")}
        </label>
      </div>
      <div className="px-3 py-3">
        <div className="row">
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label">{t("invoice.receivedDate")}</label>
            <DatePicker
              selected={invoice?.recordDate}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm"
              name="receivedDate"
              disabled
              showDisabledMonthNavigation
              onChange={(date) => handleChange(null, "recordDate", date)}
              customInput={<input className="form-control form-control-sm" />}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <div className="input-length-validation">
              <label className="field-label" htmlFor="supplierCode">{t("invoice.supplierCode")}</label>
              <input
                type="text"
                className="form-control form-control-sm"
                id="supplierCode"
                name="supplierCode"
                value={invoice?.purchaseInvoiceExtracted?.supplierCode ?? ""}
                onChange={(e) => handleChange("", "purchaseInvoiceExtracted.supplierCode", e.target.value, 15)}
              />
              <div
              className={`length-text ${invoice?.supplierCode?.length == 15 ? "text-danger" : ''}`}>
                {invoice?.purchaseInvoiceExtracted?.supplierCode?.length ?? 0}/15</div>
            </div>
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="currency">{t("invoice.currency")}</label>
            <input
              type="text"
              className="form-control form-control-sm"
              name="currency"
              id="currency"
              value={invoice?.purchaseInvoiceExtracted?.currency ?? ""}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="exRate">{t("invoice.exchangeRate")}</label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="exRate"
              name="exRate"
              value={invoice?.purchaseInvoiceExtracted?.exRate ?? ""}
              onChange={handleChange}
              disabled
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <div className="input-length-validation">
              <label className="field-label" htmlFor="supplierInvoiceInfo">{t("purchases.supplierInvoiceInfo")}</label>
              <textarea
                type="text"
                className="form-control form-control-sm"
                id="supplierInvoiceInfo"
                name="supplierInvoiceInfo"
                disabled
                rows="1"
                value={invoice?.purchaseInvoiceExtracted?.supplierInvoiceInfo ?? ""}
                required
              />
            </div>
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="priority.name">
              {t("invoice.priorityCombo")}
            </label>
            <Select
              styles={selectStyle}
              options={priorityOptions}
              placeholder={t("invoice.select")}
              value={priorityOptions.find(
                (priority) =>
                priority.value === invoice?.purchaseInvoiceExtracted?.priority?.name)}
              isSearchable={true}
              onChange={(priority) =>
                handleChange(null, "purchaseInvoiceExtracted.priority.name", priority.value)
              }
              name="priority.name"
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="valueWoVat">
              {t("item.totalWithoutVat")}
            </label>
            <input
              type="text"
              id="valueWoVat"
              name="valueWoVat"
              className="form-control form-control-sm"
              disabled
              value={func.formatNumber(invoice?.purchaseInvoiceExtracted?.valueWoVat)}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="vatValue">Vat Value</label>
            <input
              type="text"
              id="vatValue"
              name="vatValue"
              className="form-control form-control-sm"
              disabled
              value={func.formatNumber(invoice?.purchaseInvoiceExtracted?.vatValue)}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="valueWVat">
              {t("item.totalWithVat")}
            </label>
            <input
              type="text"
              id="valueWVat"
              name="valueWVat"
              className="form-control form-control-sm"
              disabled
              value={func.formatNumber(invoice?.purchaseInvoiceExtracted?.valueWVat)}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label" htmlFor="purchaseUnit">{t("purchases.purchaseUnit")}</label>
            <Select
              styles={selectStyle}
              options={tcrList}
              value={tcrList.find(
                (purchaseUnit) =>
                  purchaseUnit.value === invoice?.purchaseInvoiceExtracted?.purchaseUnit
              )}
              isSearchable={true}
              onChange={(purchaseUnit) =>
                handleChange("", "purchaseInvoiceExtracted.purchaseUnit", purchaseUnit.value)
              }
              isDisabled={![8,13].includes(user?.purchaseRole?.id)}
              placeholder={t("invoice.select")}
              name="purchaseUnit"
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label">{t("purchases.paymentRequestedDate")}</label>
            <DatePicker
              selected={invoice?.dueDateTime}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm"
              name="dueDateTime"
              disabled
              showDisabledMonthNavigation
              customInput={<input className="form-control form-control-sm" />}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <label className="field-label">{t("purchases.expectedAcceptanceDateInternal")}</label>
            <DatePicker
              selected={invoice?.purchaseInvoiceExtracted?.expectedAcceptanceDate}
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm"
              name="purchaseInvoiceExtracted.expectedAcceptanceDate"
              minDate={ invoice?.dueDateTime ?? ""}
              showDisabledMonthNavigation
              onChange={(expectedAcceptanceDate) =>
                handleChange(
                  null,
                  "purchaseInvoiceExtracted.expectedAcceptanceDate",
                  expectedAcceptanceDate
                )
              }
              customInput={<input className="form-control form-control-sm" />}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <InternalPoCombo
              invoice={invoice}
              handleChange={handleChange}
            />
          </div>
          <div className="col-12 col-md-6 mb-2">
            <InternalAgreementCombo
              invoice={invoice}
              handleChange={handleChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalInfo;
